qw-book {
  display: flex;
  flex-direction: column;
}

.qw-book__wrapper, .qw-book__error-quote {
  padding: var(--qw-hotel-gap-sm);
}

.qw-book__error-quote {
  border: 1px solid var(--qw-hotel-accent-color);
}

.qw-book__special-requests__title {
  display: flex;
}

.qw-book__special-requests__title h4 {
  margin-right: var(--qw-hotel-gap-md);
}

.qw-book__special-requests__caption {
  font-size: 70%;
  margin-bottom: var(--qw-hotel-gap-md);
}

.qw-book__confirmation-checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.qw-book__confirmation-checkbox qw-input {
  width: 50px;
}

.qw-book__form-error {
  margin-top: var(--qw-hotel-gap-md);
  padding: var(--qw-hotel-gap-sm);
  border: 1px solid var(--qw-hotel-accent-color);
}

.qw-book__form-error > ul {
  padding-inline-start: var(--qw-hotel-gap-lg);
}

.qw-book__pay {
  margin-top: var(--qw-hotel-gap-md);
}

.qw-book__insurance {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid var(--qw-hotel-neutral-light);
  padding: var(--qw-hotel-gap-md);
}

.qw-book__insurance h3, h4 {
  margin: 0;
}

.qw-book__insurance .insurance__heading {
  width: 10%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: var(--qw-hotel-gap-md) 0;
}

.qw-book__insurance .insurance__heading img {
  margin-right: var(--qw-hotel-gap-sm);
}

.qw-book__insurance .insurance__content {
  width: 80%;
  display: flex;
  flex-flow: column;
}

.qw-book__insurance .insurance__content .insurance__link {
  display: block;
  margin-bottom: var(--qw-hotel-gap-md);
}

.qw-book__insurance-acceptance-actions {
  width: 10%;
  display: flex;
  justify-content: flex-start;
}

.qw-book__insurance-acceptance-actions .qw-button {
  margin-right: var(--qw-hotel-gap-md);
  --qw-button-background: var(--qw-hotel-neutral-light);
}

.qw-book__insurance-acceptance-actions .qw-button.insurance__action--selected {
  --qw-button-background: var(--qw-hotel-secondary-color);
}

qw-book .confirmation-conditions {
  cursor: pointer;
  text-decoration: underline;
}

@media only screen and (max-width: 1000px) {
  .qw-book__insurance {
    flex-flow: column;
  }
  .qw-book__insurance .insurance__heading {
    width: 100%;
  }
  .qw-book__insurance .insurance__content {
    width: 100%;
  }
}
